import React, { memo } from 'react';
import { Container, List, ListItem } from '@groupelacentrale/contact-storybook';
import { IconAllIn, IconExpertise, IconValueOutline } from '@groupelacentrale/contact-storybook/lib/icons';
import LoginPageKeysImg from 'assets/login-page-keys.png';
import './AuthPageInfo.scss';

const AuthPageInfo = memo(() => {
  return (
    <Container className="auth-page-info" shadowed paddings="mediumP" backgroundColor="bgWhite">
      <List>
        <ListItem icon={<IconValueOutline width={30} color="black" />}>
          <strong>Gratuit</strong> pour tous les véhicules
        </ListItem>
        <ListItem icon={<IconExpertise width={30} color="black" />}>
          Une <strong>visibilité maximale</strong> de votre annonce
        </ListItem>
        <ListItem icon={<IconAllIn width={30} color="black" />}>
          <strong>Tout compris</strong> : modifications gratuites, inclus 50 photos
        </ListItem>
      </List>

      <div>
        <img src={LoginPageKeysImg} alt="Vendre sa voiture" />
      </div>
    </Container>
  );
});

AuthPageInfo.displayName = 'AuthPageInfo';

export { AuthPageInfo };
